import React, { Fragment, useEffect, useState } from 'react';
import { Card, CardHeader, Col } from 'reactstrap';
import { Breadcrumbs, H5 } from '../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Edit, } from 'react-feather';
import { listAPI } from './Service/ManageClinicUsersService';
import { useLoader } from './../../_helper/LoaderContext';
import doctor from '../../assets/images/docotr.webp'
const Profile = () => {

    const history = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const [totalItems, setTotalItems] = useState(0);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [listData, setList] = useState([]);
    const { setLoading } = useLoader();
    const { t } = useTranslation();
    const [isClearing, setIsClearing] = useState(false);
    const imageBaseURL = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        // Fetch List data when component mounts
        getList();
    }, [page, size]);

    const getList = async () => {
        const body = {
            pageNo: page,
            pageSize: size,
            search: searchValue.trim(),
            role: "doctor"
        }
        try {
            setLoading(true);
            const response = await listAPI(body)
            if (response) {
                setList(response.data.data.doctor);
                const totalCount = response.data.data.counts;
                const totalPagesItems = Math.ceil(totalCount / size);
                setTotalItems(totalPagesItems);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    };

    // Handle search button click
    const handleSearchButtonClick = () => {
        setPage(1); // Reset page to 1
        getList(); // Trigger the API call for search
    };

    const handleClear = () => {
        setIsClearing(true);
        setSearchValue(''); // Clear the search value
    };

    useEffect(() => {
        if (isClearing) {
            getList(); // Trigger the API call when clearing search
            setIsClearing(false); // Reset clearing state
        }
    }, [isClearing]);

    // Handle search field input change (but don't trigger API call)
    const handleSearchChange = (event) => {
        setSearchValue(event.target.value); // Just update the state
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (e) => {
        const newSize = parseFloat(e.target.value); // Parse the value without triggering a state update
        setSize(newSize); // Update the state after parsing the value
        setPage(1); // Reset currentPage to 1 when changing page size
    }

    const updateProfile = () => {
        history(`${process.env.PUBLIC_URL}/update-profile`);
    };

    // Event handler for opening edit component
    const handleEditClick = (getID) => {
        // console.log(getID);
        history(`${process.env.PUBLIC_URL}/manage-doctor/edit/${getID}`);
    };

    // Event handler for opening view component
    const handleViewClick = (getID) => {
        // console.log(getID);
        history(`${process.env.PUBLIC_URL}/manage-doctor/view/${getID}`);
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle={t('profile')} parent={t('Dashboard')} title={t('profile')} />
            <Col sm="12">
                <Card>
                    <CardHeader className="d-flex justify-content-between align-items-center">
                        <H5>{t('profile')}</H5>
                        <button
                            className="btn btn-primary d-flex align-items-center"
                            style={{ color: 'white', height: "40px" }}
                            to=""
                            onClick={updateProfile}>
                            <Edit className="me-2" /> {t("updateProfile")}
                        </button>
                    </CardHeader>

                </Card>
                <div className='row tw-pb-2'>
                    <div className='col-sm-12 col-md-6 col-xl-4'>
                        <div className="tw-m-2 md:tw-m-0 tw-max-w-md tw-bg-white tw-rounded-2xl tw-shadow-lg tw-overflow-hidden tw-mx-auto tw-mt-4">
                            {/* Header */}
                            <div className="tw-bg-gray-900 tw-p-4 tw-relative tw-flex tw-items-center tw-justify-between tw-h-28">
                                {/* <FontAwesomeIcon icon={faEdit} className="tw-text-white tw-text-lg tw-cursor-pointer tw-absolute tw-top-4 tw-right-4" /> */}

                            </div>

                            {/* Body */}
                            <div className="tw-p-6 tw-relative">
                                <div className="tw-flex tw-justify-center">
                                    <img
                                        src={doctor}
                                        alt="Doctor"
                                        className="tw-w-32 tw-h-32 tw-rounded-md tw-border-4 tw-border-white tw-relative tw-mt-[-70px]"
                                    />
                                </div>
                                <h2 className="tw-text-xl tw-font-bold tw-text-center tw-mb-2 tw-pt-2">Dr. Kudzai Masango</h2>
                                <p className="tw-text-center tw-text-gray-500 tw-mb-4">(Male)</p>
                                <p className="tw-text-center tw-text-gray-700 tw-mb-4">Cardiologist & General Medicine</p>

                                <div className="tw-text-sm tw-text-gray-700 tw-mb-4">
                                    <span className="tw-font-semibold">Professional Registration Number:</span> RF789456632288
                                </div>

                                {/* Contact Buttons */}
                                <div className="tw-flex tw-flex-col tw-gap-3 tw-mb-4">
                                    <button className="tw-flex tw-items-center tw-gap-3 tw-py-2 tw-px-4 tw-bg-gray-800 tw-text-white tw-rounded-md tw-justify-center tw-border-none">
                                        {/* <FontAwesomeIcon icon={faEnvelope} />  */}
                                        kudzai@gmail.com
                                    </button>
                                    <button className="tw-flex tw-items-center tw-gap-3 tw-py-2 tw-px-4 tw-bg-blue-600 tw-text-white tw-rounded-md tw-justify-center tw-border-none">
                                        {/* <FontAwesomeIcon icon={faPhone} /> */}
                                        +263 7689451223
                                    </button>
                                    <button className="tw-flex tw-items-center tw-gap-3 tw-py-2 tw-px-4 tw-bg-green-500 tw-text-white tw-rounded-md tw-justify-center tw-border-none">
                                        {/* <FontAwesomeIcon icon={faWhatsapp} /> */}
                                        +263 7689451223
                                    </button>
                                </div>

                                {/* Addresses */}
                                <div className="tw-text-sm tw-text-gray-700 tw-mb-4">
                                    <p className="tw-font-semibold">P O Box Address</p>
                                    <p>P O Box 869, Harare.</p>

                                    <p className="tw-font-semibold tw-mt-4">Work Address</p>
                                    <p>65 Churchill Avenue, Harare.</p>

                                    <p className="tw-font-semibold tw-mt-4">Home Address</p>
                                    <button className="btn tw-text-green-600 tw-flex tw-items-center">
                                        {/* <FontAwesomeIcon icon={faPlus} className="tw-mr-2" />  */}
                                        Please add this address
                                    </button>
                                </div>

                                {/* About */}
                                <div className="tw-text-sm tw-text-gray-700 tw-mt-4">
                                    <p className="tw-font-semibold">About</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Fragment>
    )
};

export default Profile;
